import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import { Form as FinalForm, Field } from 'react-final-form';
import { intlShape, injectIntl } from 'react-intl';
import classNames from 'classnames';

import {
  FieldDateInput,
  Form,
  IconArrow,
  LocationAutocompleteInputField,
  PrimaryButton,
} from '../../components';

import css from './TopbarSearchForm.css';

const TopbarSearchForm = props => {
  const {
    rootClassName,
    className,
    onSubmit,
    hideSearch,
    isMobile,
    withSearchButton,
    initialValues,
    intl,
  } = props;
  const [canRender, setCanRender] = useState(false);
  const [searchInput, setSearchInput] = useState(null);
  const [location, setLocation] = useState(path(['initialValues', 'location'], props));

  useEffect(() => {
    setCanRender(true);
  })

  if (!canRender) return null;

  const handleChangeLocation = (location) => {
    if (location.selectedPlace) {
      // Note that we use `onSubmit` instead of the conventional
      // `handleSubmit` prop for submitting. We want to autosubmit
      // when a place is selected, and don't require any extra
      // validations for the form.
      setLocation(location);
      // blur search input to hide software keyboard
      if (searchInput) {
        searchInput.blur();
      }
      if (withSearchButton) return;
    }
  };
  const initialDateValue = initialValues.date;
  const initialDateFormatted = initialDateValue && new Date(initialDateValue);
  const initialLocationValue = initialValues.location;
  const initialValuesFormatted = {
    ...(initialDateValue ? { date: initialDateFormatted } : {}),
    ...(initialLocationValue ? { location: initialLocationValue } : {})
  };

  return (
    <FinalForm
      {...props}
      initialValues={initialValuesFormatted}
      onSubmit={(values) => {
        // e.preventDefault();
        const { onSubmit } = props;
        if (!path(['selectedPlace'], location)) {
          searchInput.focus();
          return;
        }
        hideSearch();
        onSubmit({ location, date: values.date });
      }}
      render={formRenderProps => {
        const { rootClassName, className, intl, handleSubmit, withSearchButton } = formRenderProps;
        const classes = classNames(rootClassName || css.container, className);

        // Allow form submit only when the place has changed
        const preventFormSubmit = e => e.preventDefault();

        const locationLabel = intl.formatMessage({ id: 'TopbarSearchForm.locationLabel' })
        const locationPlaceholder = intl.formatMessage({ id: 'TopbarSearchForm.locationPlaceholder' })

        const dateLabel = intl.formatMessage({ id: 'TopbarSearchForm.dateLabel' })
        const datePlaceholder = intl.formatMessage({ id: 'TopbarSearchForm.datePlaceholder' })
        // const handleSubmit = (e, ...rest) => {
        //   e.preventDefault();
        //   console.log('handleSubmit', e, rest)
        // };

        const searchButtonText = intl.formatMessage({ id: 'TopbarSearchForm.searchButton' });

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <Field
              name="location"
              format={null}
              render={({ input, meta }) => {
                const { onChange, ...restInput } = input;
                // Merge the standard onChange function with custom behaviur. A better solution would
                // be to use the FormSpy component from Final Form and pass this.onChange to the
                // onChange prop but that breaks due to insufficient subscription handling.
                // See: https://github.com/final-form/react-final-form/issues/159
                const searchOnChange = value => {
                  onChange(value);
                  handleChangeLocation(value);
                };
                const searchInput = { ...restInput, onChange: searchOnChange };

                return (
                  <LocationAutocompleteInputField
                    rootClassName={css.locationContainer}
                    iconClassName={css.icon}
                    inputClassName={css.input}
                    predictionsClassName={css.predictions}
                    predictionsAttributionClassName={css.mobilePredictionsAttribution}
                    label={locationLabel}
                    placeholder={locationPlaceholder}
                    // closeOnBlur={!isMobile}
                    inputRef={node => {
                      setSearchInput(node);
                    }}
                    input={searchInput}
                    meta={meta}
                    // validate={composeValidators(
                    //   required(placeRequiredMessage),
                    // )}
                  />
                );
              }}
            />
            <FieldDateInput
              className={css.containerDate}
              name="date"
              id="date"
              isSearch
              label={dateLabel}
              placeholderText={datePlaceholder}
              format={null}
              timeSlots={[]}
              useMobileMargins
              initialDate={initialDateFormatted}
            />
            <PrimaryButton type="submit" className={css.searchButton}>
              <span className={css.searchButtonText}>{searchButtonText}</span>
              <IconArrow className={css.iconArrow} direction='right' />
            </PrimaryButton>
          </Form>
        );
      }}
    />
  )
}

const { func, string, bool } = PropTypes;

TopbarSearchForm.defaultProps = {
  rootClassName: null,
  className: null,
  isMobile: false,
};

TopbarSearchForm.propTypes = {
  rootClassName: string,
  className: string,
  onSubmit: func.isRequired,
  hideSearch: func,
  isMobile: bool,
  withSearchButton: bool,

  // from injectIntl
  intl: intlShape.isRequired,
};

export default injectIntl(TopbarSearchForm);



// WEBPACK FOOTER //
// ./src/forms/TopbarSearchForm/TopbarSearchForm.js